// extracted by mini-css-extract-plugin
module.exports = {"releated_box":"paXn3","releated_list":"rriHi","list":"_tZzW"};